export { ViewContactsBlockComponent } from './contacts-block/view-contacts-block.component';
export { ViewHeaderComponent, BreadcrumbItem } from './header';
export { ViewImagesCarouselComponent } from './images-carousel/view-images-carousel.component';
export { ViewInfoBlockComponent } from './info-block/view-info-block.component';
export { DiscountDialogComponent } from './discount-dialog/discount-dialog.component';
export { DiscountGroupsDialogComponent } from './discount-groups-dialog/discount-groups-dialog.component';
export { DiscountGroupRowComponent } from './discount-groups-dialog/components';
export { SimilarProductsComponent } from './similar-products/similar-products.component';
